import TestimonialSection from "../common/TestimonialSection";
import TrustBox from "../common/TrustBox";
import { logEvent } from "../Analytics/google-analytics";
import { trackClick } from "../../scripts/segment";
import { pageName } from "../../lib/utils/events_utils";
import Link from "next/link";
import { pageRoutes } from "constant/routes";
import { useEffect } from "react";

const Testimonials = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src =
      "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);
  
  return (
    <div className="bg-blue-950 md:min-h-1000">
      <div className="max-w-page-width mx-auto px-4 pt-12 md:pt-24 pb-12 border-blue-1000">
        <p className="text-22 md:text-5xl text-white font-bold pt-4">
          What our students say
        </p>
        <div className="pt-5 md:pt-8">
          <TestimonialSection />
        </div>
        <div className="flex justify-center mt-12">
          <Link
            href={pageRoutes.INSCHOOL_REVIEWS}
            onClick={() => {
              trackClick(pageName.HOME_PAGE, {
                widgetName: "Reviews",
                widgetFormat: "Banner",
                contentName: "View All",
                contentFormat: "Button",
              });
              logEvent("LF-Home", "Testimonials", "View All");
            }}
            className="w-full md:w-auto bg-primary text-white text-center text-l py-4 px-32 rounded-sm font-bold hover:bg-primaryLighter"
          >
            View all
          </Link>
        </div>
        <TrustBox />
      </div>
    </div>
  );
};

export default Testimonials;
